import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { cloneElement, useCallback } from 'react';

interface RegenerateMealPlanSummaryModalProps {
  children: React.ReactNode;
  onOk: () => void;
  onBack: () => void;
}

const RegenerateMealPlanSummaryModal: React.FC<
  RegenerateMealPlanSummaryModalProps
> = ({ onOk, onBack, children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleConfirm = useCallback(() => {
    onOk();
    onClose();
  }, [onOk, onClose]);

  const handleBack = useCallback(() => {
    onBack();
    onClose();
  }, [onBack, onClose]);

  return (
    <>
      {cloneElement(children as any, { onClick: onOpen })}

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        closeOnOverlayClick={false}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          overflow="hidden"
          borderRadius={10}
          backgroundColor="white"
        >
          <ModalHeader
            fontWeight="600"
            borderBottom="1px solid"
            borderBottomColor="gray.400"
          >
            <Flex
              width="100%"
              justifyContent="space-between"
              alignItems="center"
            >
              <Text>Regenerate outline</Text>
              <ModalCloseButton position="unset" size="lg" />
            </Flex>
          </ModalHeader>
          <ModalBody position="relative" paddingTop={4}>
            <Text as="p" size="sm">
              This will regenerate the outline using your current preferences
              and overwrite any edits. To change your preferences first, go
              back.
            </Text>
          </ModalBody>
          <ModalFooter gap="4">
            <Button variant="ghost" onClick={handleBack}>
              Back to preferences
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="orange" onClick={handleConfirm}>
              Regenerate
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default RegenerateMealPlanSummaryModal;
